import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_requestMemoInput} from "../../../function/FnBodySetting";
import {fn_request_memo_delete_layer} from "../../../function/FnBodyLayer";

@observer
class SettingDefaultRequestMemoKitchenView extends Component {

    constructor(props) {
        super(props);
        this.state={kitchenMemoValue:"", kitchenMemoFild:""}
    }

    componentWillUnmount() {
        this.setState({kitchenMemoFild:"", kitchenMemoValue:""});
    }

    kitchenList = (kitchenRequestMemoList) => {
        const { rootStore } = this.props;
        if (Array.isArray(kitchenRequestMemoList) && kitchenRequestMemoList.length > 0){
            return (
                <ul className="list_address">
                    {
                        kitchenRequestMemoList.map((obj, index)=>(
                            <li key={index}>
                                <strong>{obj.memo_nm}</strong>
                                <button className="btn_delete" onClick={e=>this.deleteMemo(obj)}><span>삭제</span></button>
                            </li>
                        ))
                    }
                </ul>
            )
        }else {
            return (
                <div className="box_self_delivery_none">
                    <div className="tit"><strong>등록된 메시지가 없어요</strong></div>
                    <p>자주 사용하는 주방요청 메시지를 등록해보세요.</p>
                </div>
            )
        }
    }

    validateCheck = kitchenMemoFild => {
        const { rootStore } = this.props;

        this.setState({kitchenMemoFild:true, kitchenMemoValue:kitchenMemoFild.value});

    }

    handleSubmit = (event) => {
        const { rootStore } = this.props;
        event.preventDefault();
        fn_requestMemoInput(rootStore, this.state.kitchenMemoValue)
        this.setState({kitchenMemoFild: "", kitchenMemoValue: ""});
    }

    deleteMemo = (obj) => {
        const { rootStore } = this.props;
        rootStore.settingStore.setRequestMemoDelete(obj)
        fn_request_memo_delete_layer(rootStore)
    }

    render() {
        const { rootStore } = this.props;
        const kitchenRequestMemoList = rootStore.settingStore.getKitchenRequestMemo;

        return(
            <div className="scroll tab">
                <div className="inner">
                    <div className="wrap_request">
                        <div className="box_tit">
                            <h4>주방요청 메시지 관리</h4>
                            <span>CID 주문등록 시, 주방요청사항 간편 입력 버튼 설정</span>
                        </div>
                        <div className="box_register">
                            <strong className="tit">주방요청 입력</strong>
                            <form name="manInfo" onSubmit={this.handleSubmit}>
                                <input type="text" className="inp_register" maxLength={10}  placeholder="메시지를 입력해주세요." required
                                       value={this.state.kitchenMemoValue} onChange={e => this.validateCheck(e.target)}/>
                                <button type="submit" className="btn_register">등록</button>
                            </form>
                            <ul>
                                <li>주방주문서에 출력될 주방요청 메시지를 등록해주세요</li>
                                <li>최대 한글 10자까지 입력 가능</li>
                                <li className="import">변경사항은 포스 재실행 후 적용됩니다.</li>
                            </ul>
                        </div>
                        {this.kitchenList(kitchenRequestMemoList)}
                    </div>
                </div>
            </div>
        )
    }
}

export default SettingDefaultRequestMemoKitchenView;